import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import BolsaTrabajo from "./pages/BolsaTrabajo";
import Nosotros from "./pages/Nosotros";
import Programas from "./pages/Programas";
import Contacto from "./pages/Contacto";
import Noticias from "./pages/Noticias";
import PerfilYucatan from "./pages/PerfilYucatan";
import Servicios from "./pages/Servicios";
import InvierteYucatan from "./pages/InvierteYucatan";
import Normatividad from "./pages/Normatividad";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/bolsa-trabajo" element={<BolsaTrabajo />} />
          <Route path="/noticias" element={<Noticias />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/programas" element={<Programas />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/perfil-yucatan" element={<PerfilYucatan />} />
          <Route path="/servicios" element={<Servicios />} />
          <Route path="/invierte-yucatan" element={<InvierteYucatan />} />
          <Route path="/normatividad" element={<Normatividad />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
